module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', _vm._g({
    class: ['p-inputtext p-component', {
      'p-filled': _vm.filled
    }],
    domProps: {
      "value": _vm.value
    }
  }, _vm.listeners))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a0601dd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/inputtext/InputText.vue
// module id = 2284
// module chunks = 0